import { render, staticRenderFns } from "./cpt-iframe.vue?vue&type=template&id=53899266&scoped=true"
import script from "./cpt-iframe.vue?vue&type=script&lang=js"
export * from "./cpt-iframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53899266",
  null
  
)

export default component.exports